import {
    Box,
    Container,
    Typography,
    Card,
    CardContent,
    Button,
    Grid,
    Chip,
    Skeleton,
    IconButton,
    Alert,
} from "@mui/material";
import ElectricBoltOutlinedIcon from "@mui/icons-material/ElectricBoltOutlined";
import FlowentiLogo from "../../image/Logo.svg"; //# use this cause is without background
import useStripeBilling from "hooks/useStripeBilling";
import { Switch } from "@mui/material";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useState } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { useSelectedOrganization, useTranslations, useUser } from "hooks";
import CustomBillingButton from "components/CustomBillingButton";
import { getTranslation } from "common";
import FlowentiButton from "components/flowenti-ui-kit/FlowentiButton";
// import { useLocation } from "react-router-dom";

const Billing: React.FC = () => {
    const {
        formatPrice,
        handleSelectPlan,
        loading,
        navigate,
        rules,
        stripeLoading,
        loadingButton,
        activeSubscription,
        billingInterval,
        setBillingInterval,
        getPriceByInterval,
        handleUpgradePlan,
        allSubscriptions,
        isSuggestedPlan,
    } = useStripeBilling();
    // const location = useLocation();
    // const organizationNameFromNavigation = location.state?.organizationName;
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [pendingUpgrade, setPendingUpgrade] = useState<{ priceId: string, subId: string }>({ priceId: '', subId: '' });
    const subId = allSubscriptions.find(sub => sub.current_price_id === activeSubscription)?.idsubscription || ""
    const organization = useSelectedOrganization()
    const currentOrganizationSubscription = allSubscriptions.find(sub => sub.idorganization === organization?.id);
    const user = useUser();
    const hasSubCancelPending = currentOrganizationSubscription?.status_history[0].status !== "active"
    const translations = useTranslations();
    const featureTextSx = {
        color: (theme: any) =>
            theme.palette.mode === "dark" ? theme.palette.text.secondary : "#374151",
    };
    const smallFeatureTextSx = {
        ...featureTextSx,
        fontSize: "12px",
    };
    // console.log(organization?.name)

    return (
        <Container maxWidth="xl" sx={{ overflow: "none" }}>
            <Box sx={{ mb: 6 }}>
                <Box display={"flex"} alignItems="center" flexGrow={1} sx={{ mb: 4, justifyContent: "space-between" }}>
                    <Box display="flex" alignItems="center">
                        <IconButton onClick={() => navigate(user ? '/dashboard/organizations' : '/')}>
                            <Box
                                component="img"
                                alt="..."
                                sx={{
                                    width: { xs: "44px", sm: "60px", md: "88px" },
                                    height: { xs: "44px", sm: "60px", md: "88px" },
                                }}
                                src={FlowentiLogo}
                            />
                        </IconButton>
                        <Typography sx={{
                            fontFamily: "Poppins-Light",
                            fontWeight: 400,
                            fontSize: { xs: "24px", sm: "32px", md: "50px" },
                            color: "rgb(84, 189, 193)",
                            cursor: "pointer",
                        }}
                            onClick={() => navigate(user ? '/dashboard/organizations' : '/')}>
                            Flowenti
                        </Typography>
                    </Box>
                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: "1rem", md: "2.5rem" },
                            color: "rgb(84, 189, 193)",
                            mt: 2
                        }}
                    >
                        {getTranslation(translations, "general_billing.plans")}
                    </Typography>
                </Box>
                <Typography
                    variant="h6"
                    sx={{
                        color: "#6b7280",
                        fontWeight: 400,
                        fontSize: "1.125rem",
                        mb: 4,
                    }}
                >
                    {getTranslation(translations, "generic_billing.subtitle")}
                </Typography>
                <Box display="flex" alignItems="center" justifyContent="center" mb={4}>
                    <Typography sx={{ mr: 1 }}>{getTranslation(translations, "generic.monthly")} </Typography>
                    <Switch
                        checked={billingInterval === "year"}
                        onChange={() => setBillingInterval(billingInterval === "month" ? "year" : "month")}
                        color="primary"
                    />
                    <Typography sx={{ ml: 1 }}>{getTranslation(translations, "generic.yearly")} </Typography>
                </Box>
            </Box>
            {loading || stripeLoading ? <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, alignItems: "stretch" }}>
                {[1, 2, 3, 4, 5].map((i) => (
                    <Box key={i} sx={{ minWidth: 280, flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 12px)", md: "1 1 calc(20% - 12px)" }, height: 400 }}>
                        <Skeleton variant="rectangular" height="100%" sx={{ borderRadius: 2 }} />
                    </Box>
                ))}
            </Box> : <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, alignItems: "stretch" }}>
                {rules.map((rule) => {
                    const isRecommended = isSuggestedPlan(rule);
                    const activeSub = Boolean(rule.prices.find(price => price.provider_price_id === activeSubscription && price.interval === billingInterval));
                    const price = rule.is_free ? undefined : getPriceByInterval(rule, billingInterval);

                    return (
                        <Box key={`${rule.id}-${activeSubscription}`} sx={{ minWidth: 280, flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 12px)", md: "1 1 calc(20% - 12px)" }, position: "relative" }}>
                            {isRecommended && (
                                <Chip
                                    icon={<ElectricBoltOutlinedIcon />}
                                    size='small'
                                    label={getTranslation(translations, "generic.suggested")}
                                    className='bounce'
                                    sx={{
                                        position: "absolute",
                                        right: 15,
                                        top: 3,
                                        zIndex: 1,
                                        backgroundColor: (theme) =>
                                            theme.palette.mode === "dark" ? theme.palette.primary.main : "rgb(245, 245,245)",
                                        color: (theme) =>
                                            theme.palette.mode === "dark" ? theme.palette.primary.contrastText : undefined,
                                        "& .MuiChip-icon": {
                                            color: "inherit",
                                        },
                                    }}
                                />
                            )}
                            {activeSub && !rule.is_free && (
                                <Chip
                                    label={getTranslation(translations, "generic.subscribed")}
                                    color="success"
                                    size="small"
                                    sx={{
                                        position: "absolute",
                                        left: 15,
                                        top: 3,
                                        zIndex: 1,
                                    }}
                                />
                            )}

                            <Card
                                elevation={3}
                                sx={{
                                    minHeight: 400,
                                    display: "flex",
                                    flexDirection: "column",
                                    position: "relative",
                                    border: "1px solid",
                                    borderRadius: 2,
                                    borderColor: "rgb(84, 189, 193)",
                                    height: "100%"
                                }}
                            >
                                <CardContent sx={{ flexGrow: 1, p: 4 }}>
                                    <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                                        {rule.name}
                                    </Typography>
                                    {/* <Typography variant="body2" sx={{ mb: 4, color: "#6b7280" }}>
                                        {rule.description || getTranslation(translations, "generic_billing.default_description")}
                                    </Typography> */}
                                    <Typography variant="h4" sx={{ fontWeight: 700, mb: 8 }}>
                                        {price ? `€${formatPrice(price)}` + " + " + `${getTranslation(translations, "billing.iva")}` : "Free"}
                                    </Typography>
                                    {rule && (
                                        <Box display="flex" flexDirection="column" gap={0.5}>
                                            <Box display="flex" alignItems="center">
                                                <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                                <Typography variant="body2" sx={smallFeatureTextSx}>
                                                    <strong>{getTranslation(translations, "rule.ai_model_request")}:</strong> {rule.ai_model_request}
                                                </Typography>
                                            </Box>

                                            <Box display="flex" alignItems="center">
                                                <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                                <Typography variant="body2" sx={featureTextSx}>
                                                    <strong>{getTranslation(translations, "rule.disk_storage")}:</strong> {(rule.disk_storage / (1024 * 1024)).toFixed(0)} MB
                                                </Typography>
                                            </Box>

                                            <Box display="flex" alignItems="center">
                                                <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                                <Typography variant="body2" sx={featureTextSx}>
                                                    <strong>{getTranslation(translations, "rule.process_live_max")}:</strong> {rule.process_live_max}
                                                </Typography>
                                            </Box>
                                            <Box display="flex" alignItems="center">
                                                <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                                <Typography variant="body2" sx={featureTextSx}>
                                                    <strong>{getTranslation(translations, "rule.robots_number")}:</strong> {getTranslation(translations, "generic.unlimited_caption")}
                                                </Typography>
                                            </Box>
                                        </Box>

                                    )}
                                </CardContent>
                                <Box sx={{ p: 4, pt: 0 }}>
                                    {!rule.is_free && (<FlowentiButton
                                        id={rule.id + billingInterval}
                                        variant="outlined"
                                        fullWidth
                                        size="small"
                                        // sx={{
                                        //     backgroundColor: activeSub ? "white" : "rgb(84, 189, 193)",
                                        //     color: activeSub ? "rgb(0, 11, 11)" : "white",
                                        //     borderColor: "white",
                                        //     fontWeight: 600,
                                        //     py: 1.5,
                                        //     borderRadius: 1.5,
                                        //     textTransform: "none",
                                        //     fontSize: "0.875rem",
                                        //     '&:hover': {
                                        //         backgroundColor: "rgb(60, 160, 170)",
                                        //         color: "white",
                                        //         borderColor: "white",
                                        //     },
                                        // }}
                                        onClick={() => {
                                            if (!user) {
                                                navigate("/registration");
                                                return;
                                            }
                                            const selectedPrice = getPriceByInterval(rule, billingInterval);

                                            if (rules.find(rule => (rule.prices.find(price => price.provider_price_id === activeSubscription)?.price || 0) > 0)) {
                                                setPendingUpgrade({
                                                    priceId: selectedPrice?.provider_price_id || "",
                                                    subId,
                                                });
                                                setConfirmDialogOpen(true);
                                            } else {
                                                handleSelectPlan(rule);
                                            }
                                        }}
                                        disabled={Boolean(user) && (stripeLoading || loadingButton === rule.id || activeSub || rule.is_free || hasSubCancelPending)}
                                    >
                                        {activeSub ? `${getTranslation(translations, "generic.subscribed")}` : `${getTranslation(translations, "generic.select")}`}
                                    </FlowentiButton>)}
                                    {hasSubCancelPending && !rule.is_free && user &&
                                        <Typography variant="body2" color="error" sx={{ mt: 1 }}>{getTranslation(translations, "pending.sub_alert")}</Typography>}
                                </Box>
                            </Card>
                        </Box>
                    );
                })}
                {/* Unlimited card */}
                <Box sx={{ minWidth: 280, flex: { xs: "1 1 100%", sm: "1 1 calc(50% - 12px)", md: "1 1 calc(20% - 12px)" }, position: "relative" }}>
                    <Card
                        elevation={3}
                        sx={{
                            minHeight: 400,
                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            border: "1px solid",
                            borderRadius: 2,
                            borderColor: "rgb(84, 189, 193)",
                            height: "100%"
                        }}
                    >
                        <CardContent sx={{ flexGrow: 1, p: 4 }}>
                            <Box sx={{ display: "flex" }}>
                                <ApartmentIcon sx={{ mr: 1 }} />
                                <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
                                    {getTranslation(translations, "On Premise")}
                                </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ mb: 4 }}>
                                {getTranslation(translations, "premise.billing.claim")}
                            </Typography>
                            <Box display="flex" flexDirection="column" gap={0.5}>
                                <Box display="flex" alignItems="center">
                                    <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                    <Typography variant="body2" sx={smallFeatureTextSx}>
                                        <strong>{getTranslation(translations, "rule.ai_model_request")}:</strong> {getTranslation(translations, "generic.unlimited_caption")}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                    <Typography variant="body2" sx={featureTextSx}>
                                        <strong>{getTranslation(translations, "rule.disk_storage")}:</strong> {getTranslation(translations, "generic.unlimited_caption")}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                    <Typography variant="body2" sx={featureTextSx}>
                                        <strong>{getTranslation(translations, "rule.process_live_max")}:</strong> {getTranslation(translations, "generic.unlimited_caption")}
                                    </Typography>
                                </Box>
                                <Box display="flex" alignItems="center">
                                    <CheckIcon sx={{ color: "#10b981", fontSize: "1.25rem", mr: 1 }} />
                                    <Typography variant="body2" sx={featureTextSx}>
                                        <strong>{getTranslation(translations, "rule.robots_number")}:</strong> {getTranslation(translations, "generic.unlimited_caption")}
                                    </Typography>
                                </Box>
                            </Box>
                        </CardContent>
                        <Box sx={{ p: 4, pt: 0 }}>
                            {/* <Alert severity="info">
                                {getTranslation(translations, "Pricing upon request")}
                            </Alert> */}
                            <CustomBillingButton />
                        </Box>
                    </Card>
                </Box>
            </Box>
            }
            <Dialog sx={{ zIndex: 9999 }}
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
            >
                <DialogTitle>{getTranslation(translations, "upgrade_plan_confirm.title")}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {getTranslation(translations, "upgrade_plan_confirm.text")}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmDialogOpen(false)} color="inherit">
                        {getTranslation(translations, "generic.button.cancel")}
                    </Button>
                    <Button
                        id="confirm-update-button"
                        onClick={() => {
                            handleUpgradePlan(pendingUpgrade.priceId, pendingUpgrade.subId);
                            setConfirmDialogOpen(false);
                        }}
                        color="primary"
                        variant="contained"
                    >
                        {getTranslation(translations, "generic.button.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>
            {/* <CustomBillingButton /> */}
        </Container >
    );
};

export default Billing;
